import React from 'react';
import { CloseButton, Flex, Heading, Text } from '@marvelapp/ui';
import { CopyToClipboard } from '@marvelapp/ui-internal';
export default function c(_a) {
    var onClose = _a.onClose, subheading = _a.subheading, title = _a.title;
    return (React.createElement(Flex, { alignItems: "center", bg: "rgba(255,255,255,0.9)", boxShadow: "projectBar", justifyContent: "space-between", paddingLeft: 4, paddingRight: 4, position: "relative", py: 3, zIndex: "navigationBar" },
        React.createElement(Flex, { alignItems: "center" },
            React.createElement("div", null,
                React.createElement(Heading, { fontSize: 4, fontWeight: 500, marginBottom: 1 }, title),
                React.createElement(Text, { color: "slate", fontSize: 2, marginTop: 1 }, subheading))),
        React.createElement(Flex, null,
            React.createElement(CopyToClipboard, { btnText: "Copy link", kind: "ghost", size: 1, text: window.location.href }),
            React.createElement(CloseButton, { marginLeft: 2, onClick: onClose, size: 1 }))));
}
